import { useState } from 'react';
import { Boot } from './components/Boot';
import { Login } from './components/Login';
import { Desktop } from './components/Desktop';

/**
 * Three stages, in order: the machine powers on, it asks who it is working for,
 * then it hands over the desk. The gate is a real stage rather than a modal so
 * that no desk can be mounted — or reach the wallet — before the operator has
 * chosen.
 */
type Stage = 'boot' | 'login' | 'desktop';

export default function App() {
  const [stage, setStage] = useState<Stage>('boot');

  if (stage === 'boot') return <Boot onDone={() => setStage('login')} />;
  if (stage === 'login') return <Login onDone={() => setStage('desktop')} />;
  return <Desktop />;
}
